/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import AbstractResponsiveComponent from './AbstractResponsiveComponent';

class BannerTitleContent extends Component {
	view() {
		return <h2 className={this.attrs.className}>{m.trust(this.attrs.deviceData)}</h2>;
	}
}

export default class BannerTitle extends AbstractResponsiveComponent {
	get data() {
		return this.attrs.banner.content()?.title;
	}

	getClassName() {
		return `${super.className} BannerTitle`;
	}

	get content() {
		return BannerTitleContent;
	}
}
